var map = {
	"./news-4-1.jpg": 72138,
	"./news-4-10.jpg": 94088,
	"./news-4-11.jpg": 38053,
	"./news-4-12.jpg": 33850,
	"./news-4-13.jpg": 5015,
	"./news-4-14.jpg": 98700,
	"./news-4-15.jpg": 70313,
	"./news-4-16.jpg": 90718,
	"./news-4-17.jpg": 75675,
	"./news-4-18.jpg": 92896,
	"./news-4-19.jpg": 18461,
	"./news-4-2.jpg": 39477,
	"./news-4-20.jpg": 96697,
	"./news-4-21.jpg": 99324,
	"./news-4-22.jpg": 67019,
	"./news-4-23.jpg": 40558,
	"./news-4-24.jpg": 35093,
	"./news-4-25.jpg": 44184,
	"./news-4-26.jpg": 6759,
	"./news-4-27.jpg": 84106,
	"./news-4-28.jpg": 3633,
	"./news-4-29.jpg": 25108,
	"./news-4-3.jpg": 48568,
	"./news-4-30.jpg": 21762,
	"./news-4-31.jpg": 29823,
	"./news-4-32.jpg": 46096,
	"./news-4-33.jpg": 7341,
	"./news-4-34.jpg": 91142,
	"./news-4-35.jpg": 81251,
	"./news-4-36.jpg": 35188,
	"./news-4-37.jpg": 6993,
	"./news-4-38.jpg": 35882,
	"./news-4-39.jpg": 3623,
	"./news-4-4.jpg": 55051,
	"./news-4-5.jpg": 28590,
	"./news-4-6.jpg": 1081,
	"./news-4-7.jpg": 87356,
	"./news-4-8.jpg": 31455,
	"./news-4-9.jpg": 95106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74244;